import React, { useState } from 'react';
import { Redirect } from "react-router-dom";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";

import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import { withStyles } from "@material-ui/core/styles";

import Alert from '@material-ui/lab/Alert';

import { Typography, CircularProgress, Snackbar, Grid, Button, LinearProgress } from "@material-ui/core";

import { theme } from "../../theme";
import { UserContext } from "../../contexts/UserContext";
import TotpEnrollment from "../auth/TotpEnrollment";
import TotpVerification from "../auth/TotpVerification";
import MfaOptionalPrompt from "../auth/MfaOptionalPrompt";


const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(3),
    width: "90%",
    maxWidth: 420,
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  progress: theme.progress
}));

const Login = (props) => {
  const theme = useTheme();
  const classes = useStyles();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  return (
    <UserContext.Consumer>
      {({ user, processLogin, processMfaCode, processMfaEnrollment, mfaEnrollment, mfaOptional, startOptionalMfaEnrollment, skipOptionalMfaEnrollment, authError, loginStatus, setLoginStatus }) => {

        if (loginStatus === "success") {
          return <Redirect to={props.location && props.location.state && props.location.state.referrer ? props.location.state.referrer : "/"} />;
        }

        if (loginStatus === "loading" && !user.ID)
          return <CircularProgress
            className={classes.progress}
            color="secondary"
          />;

        if (loginStatus === "mfa_optional" || loginStatus === "mfa_optional_processing") {
          return <Paper className={classes.paper}>
            <MfaOptionalPrompt
              deadline={mfaOptional.enrollment_deadline}
              processing={loginStatus === "mfa_optional_processing"}
              error={authError}
              onEnroll={startOptionalMfaEnrollment}
              onSkip={skipOptionalMfaEnrollment}
            />
          </Paper>;
        }

        if (loginStatus === "mfa_required" || (loginStatus === "mfa_processing" && !mfaEnrollment)) {
          return <Paper className={classes.paper}>
            <TotpVerification
              processing={loginStatus === "mfa_processing"}
              error={authError}
              onSubmit={processMfaCode}
            />
          </Paper>;
        }

        if (loginStatus === "mfa_enrollment_required" || (loginStatus === "mfa_processing" && mfaEnrollment)) {
          return <Paper className={classes.paper}>
            <TotpEnrollment
              enrollment={mfaEnrollment}
              processing={loginStatus === "mfa_processing"}
              error={authError}
              onSubmit={processMfaEnrollment}
            />
          </Paper>;
        }

        return (
          <Paper className={classes.paper}>
            <Typography component="h1" variant="h5" align="center">
              Anmelden
            </Typography>
            <TextField
              id="loginform-email"
              label="E-Mail Adresse"
              placeholder="E-Mail"
              className={classes.textField}
              margin="normal"
              variant="outlined"
              required={true}
              fullWidth={true}
              autoComplete="email"
              type="email"
              autoFocus
              value={email}
              onChange={(e) => { setEmail(e.target.value); }}
              onKeyDown={(e) => {
                if (e.key == "Enter") {
                  e.preventDefault();
                  if (email !== "" && password !== "")
                    processLogin(email, password);
                }
              }}
              disabled={loginStatus === "processing"}
            />

            <TextField
              id="loginform-password"
              label="Passwort"
              type="password"
              placeholder="Passwort"
              className={classes.textField}
              margin="normal"
              variant="outlined"
              required={true}
              fullWidth={true}
              value={password}
              onChange={(e) => { setPassword(e.target.value) }}
              onKeyDown={(e) => {
                if (e.key == "Enter") {
                  e.preventDefault();
                  if (email !== "" && password !== "")
                    processLogin(email, password);
                }
              }}
              disabled={loginStatus === "processing"}
              autoComplete="current-password"
            />
            <Button
              variant="contained"
              color="primary"
              size="large"
              className={classes.submit}
              fullWidth={true}
              type="submit"
              disabled={loginStatus === "processing" || email === "" || password === ""}
              onClick={() => { processLogin(email, password) }}
            >
              Login
            </Button>
            {loginStatus === "processing" ? (
              <LinearProgress color="secondary" />
            ) : (
              ""
            )}

            <Grid container>
              <Grid item xs>
                {/* <Link href="#" variant="body2">
                      Passwort vergessen?
                    </Link> */}
              </Grid>
            </Grid>
            <Snackbar open={loginStatus === "error"} autoHideDuration={6000} onClose={() => { setLoginStatus(null) }}>
              <Alert onClose={() => { setLoginStatus(null) }} severity="error">
                Die Anmeldung hat nicht geklappt, bitte versuch es nochmal.
              </Alert>
            </Snackbar>
          </Paper>
        );
      }}

    </UserContext.Consumer>
  )
}

export default Login;
